export default {
  install: (Vue, options) => {
    Vue.prototype.$helpers = {
      apiConnect(target, path, json) {
        // console.log(path, json)
        // target.$store
        //   .dispatch(path, { account_id, auth_token })
        // var feedback = {
        //   success: false,
        //   status: errorTags.request.failed
        // };
        // return new Promise((resolve, reject) => {
        //   Vue.http.post(url, json).then(
        //     successResponse => {
        //       if (successResponse) {
        //         feedback.success = typeof successResponse.data.status == "string" ? successResponse.data.status == "1" : successResponse.data.status == 1;
        //         feedback.status = successresponse.status;
        //         if (feedback.success == true) {
        //           feedback.data= successResponse.data;
        //           resolve(feedback);
        //         }
        //         else {
        //           resolve(feedback)
        //         }
        //       }
        //       else {
        //         resolve(feedback); // Response is empty...
        //       }
        //     },
        //     errorResponse => {
        //       feedback.error = errorResponse;
        //       reject(feedback);
        //     }
        //   );
        // }).catch(e => {
        //   feedback.error = e;
        //   reject(feedback);
        // });
      },
      showDialog(title, message, variant, target) {
        target.$swal({
          title: title,
          text: message,
          type: variant,
        }).then((result)=>{});
      },
      errorHandling(title, message, variant, target) {
        switch(message) {
          case "session_expired":
            target.$swal({
              title: title,
              text: target.$tc('message.list.'+message),
              type: variant
            }).then(result => {
              target.$store
                .dispatch("user/logout")
                .then(() => this.$router.push("/"))
                .catch(err => console.log(err));
            });
            break;
          default:
            break;
          }
      },
      getDateTime(datetime){
        if(datetime != null && datetime != undefined && datetime != ""){
          var returnDateTime = options.$moment(datetime).format('YYYY-MM-DD HH:mm:ss');
          return returnDateTime;
        }else{
          return "-";
        }
      },
      redirect(page) {
        return options.$router.push("/" + page).catch(error =>{});
      },
      onlyNumber($event) {
        let keyCode = ($event.which) ? $event.which : $event.keyCode;
        if (keyCode > 31 && (keyCode < 48 || keyCode > 57)){
          $event.preventDefault();
        }
      },
      onlyAlphaNum($event){
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        var regex = /^[A-Za-z0-9]+$/;
        var isValid = regex.test(String.fromCharCode(keyCode));
        if(!isValid){
          $event.preventDefault();
        }
        // if ((keyCode < 48 || keyCode > 57) && [43, 45, 46, 101, 187, 188, 189, 190].includes(keyCode)) { // prevent: "e", "=", ",", "-", "."
        //   $event.preventDefault();
        // }
      },
      onlyAlphabet($event){
        var evt = ($event) ? $event : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122)) {
          if(charCode !== 32){
            $event.preventDefault();
          }       
        }
        // let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        // var regex = /^[A-Za-z ]+$/;
        // var isValid = regex.test(String.fromCharCode(keyCode));
        // if(!isValid){
        //   $event.preventDefault();
        // }
        // var inputValue = $event.which;
        // if(!(inputValue >= 65 && inputValue <= 122) && (inputValue != 32 && inputValue != 0)) { 
        //   $event.preventDefault(); 
        // }
      },
      noSpacing($event){
        var evt = ($event) ? $event : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode == 32) {
          $event.preventDefault();      
        }
      },
      fmt(v, t = false) {
        if (v == null) return null;
        var r = v.toString();
    
        if (r == "0") {
          return "";
        }
    
        var i = r.indexOf(".");
        if (i <= 0) {
          return r;
        }
    
        var l = 4;
        var da = r.substr(i + 1, 3);
        var d1 = r.substr(i + 1, 1);
        var d2 = r.substr(i + 2, 1);
        var d3 = r.substr(i + 3, 1);
    
        if (d3 == "5") {
          l = 4;
        } else {
          if (t) {
            if (v >= 10) {
              if (da == "000") {
                l = 0;
              } else {
                if (d2 != "0") {
                  l = 3;
                } else {
                  if (d1 != "0") {
                    l = 2;
                  } else {
                    l = 0;
                  }
                }
              }
            }
          }
        }
        var rs = r.substr(0, i + l);
        return rs;
      },
      betDisplay(item, t, lang) {
        var result = "";
        switch (item.bet_type) {
          case "PARLAY":
            result = "";
            break;
          case "HDP":
          case "HDPH":
            result = item.home_away == 1 ? this.getHomeTeam(item, lang) : this.getAwayTeam(item, lang);
            break;
          case "OU":
          case "OUH":
            result = item.home_away == 1 ? t.$t("ui.over") : t.$t("ui.under");
            break;
          case "OE":
          case "OEH":
            result = item.home_away == 1 ? t.$t("ui.odd") : t.$t("ui.even");
            break;
          case "ML":
          case "MLH":
            result = item.home_away == 1 ? t.$t("m.BT_H") : t.$t("m.BT_A");
            break;
          case "1X2":
            switch (item.home_away) {
              case 1:
                result = t.$t("m.BT_FT1");
                break;
              case 2:
                result = t.$t("m.BT_FT2");
                break;
              case 3:
                result = t.$t("m.BT_FTX");
                break;
            }
            break;
          case "1X2H":
            switch (item.home_away) {
              case 1:
                result = t.$t("m.BT_HT1");
                break;
              case 2:
                result = t.$t("m.BT_HT2");
                break;
              case 3:
                result = t.$t("m.BT_HTX");
                break;
            }
            break;
          case "1X2HDP":
          case "1X2HDPH":
            switch (item.home_away) {
              case 1:
                result = t.$t("m.BT_H");
                break;
              case 2:
                result = t.$t("m.BT_A");
                break;
              case 3:
                result = t.$t("m.BT_D");
                break;
            }
            break;
          case "CS":
          case "CSH":
          case "TG":
          case "TGH":
          case "OR":
          case "BS":
            result = item.criteria1;
            break;
          case "HTFT":
          case "HTFTH":
          case "FGLG":
          case "FGLGH":
          case "CL":
          case "HNB":
          case "ANB":
          case "DNB":
          case "TWTN":
            result = t.$t("m.BT_" + item.criteria1);
            break;
          case "DC":
          case "DCH":
            result = t.$t("m.BT_" + item.criteria1 + "_DC");
            break;
        }
    
        return result;
      },
      getHomeTeam(e, lang) {
        var r = e["home_name_" + lang];
        if (r != null && r != "") {
          return r;
        }
        return e.home_team_name;
      },
      getAwayTeam(e, lang) {
        var r = e["away_name_" + lang];
        if (r != null && r != "") {
          return r;
        }
        return e.away_team_name;
      },
    };
  }
};